(function () {
  'use strict';

  var landingScreen = document.getElementById('landing-screen');
  var gameScreen = document.getElementById('game-screen');
  var gameOverScreen = document.getElementById('game-over');
  var canvas = document.getElementById('gameCanvas');
  var ctx = canvas.getContext('2d');
  var playButton = document.getElementById('play-button');
  var restartButton = document.getElementById('restart');
  var scoreEl = document.getElementById('score');
  var bestEl = document.getElementById('best');
  var hudEl = document.getElementById('game-hud');
  var sessionBestEl = document.getElementById('game-session-best');
  var incentiveEl = document.getElementById('incentive');

  var KLAVIYO_SMS_FORM_ID = 'Y3cYdE';

  document.querySelectorAll('.klaviyo-sms-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', KLAVIYO_SMS_FORM_ID]);
    });
  });

  var sessionBest = 0;

  var BEST_KEY = '20bscure_flappy_best';
  var WIN_SCORE = 50;

  var GRAVITY = 0.45;
  var FLAP_VELOCITY = -8;
  var PIPE_GAP = 190;
  var PIPE_WIDTH = 64;
  var PIPE_SPEED = 3.1;
  var PIPE_INTERVAL_MS = 1450;
  var BIRD_SIZE = 46;
  var BIRD_X_RATIO = 0.28;

  var DIFFICULTY_STEP_SCORE = 12;
  var MAX_DIFFICULTY_LEVEL = 8;
  var SPEED_PER_LEVEL = 0.4;
  var GAP_SHRINK_PER_LEVEL = 6;
  var MIN_PIPE_GAP = 140;

  function currentLevel() {
    return Math.min(MAX_DIFFICULTY_LEVEL, Math.floor(score / DIFFICULTY_STEP_SCORE));
  }

  function currentPipeSpeed() {
    return PIPE_SPEED + currentLevel() * SPEED_PER_LEVEL;
  }

  function currentPipeGap() {
    return Math.max(MIN_PIPE_GAP, PIPE_GAP - currentLevel() * GAP_SHRINK_PER_LEVEL);
  }

  var bgWords = [];
  var pointer = { x: -9999, y: -9999 };
  var REPEL_RADIUS = 130;
  var REPEL_STRENGTH = 90;

  function initBgWords() {
    var container = document.getElementById('bg-words');
    if (!container) return;

    var colors = ['#2ECC71', '#FF0A3F', '#8B2FE3'];
    var cols = 14;
    var rows = 13;
    var frag = document.createDocumentFragment();

    for (var r = 0; r < rows; r++) {
      for (var c = 0; c < cols; c++) {
        var el = document.createElement('span');
        el.className = 'bg-word';

        var inner = document.createElement('span');
        inner.className = 'bg-word-drift';
        inner.textContent = 'sinofvanity';
        el.appendChild(inner);

        var left = (c / cols) * 100 + Math.random() * (100 / cols) * 0.7;
        var top = (r / rows) * 100 + Math.random() * (100 / rows) * 0.7;
        var rot = (Math.random() * 40 - 20).toFixed(1);
        var size = 9 + Math.random() * 12;
        var duration = 5 + Math.random() * 5;
        var delay = -(Math.random() * duration);
        var opacity = 0.4 + Math.random() * 0.3;
        var color = colors[Math.floor(Math.random() * colors.length)];

        el.style.left = left + '%';
        el.style.top = top + '%';
        el.style.fontSize = size + 'px';
        el.style.opacity = opacity;
        el.style.color = color;
        inner.style.setProperty('--rot', rot + 'deg');
        inner.style.animationDuration = duration + 's';
        inner.style.animationDelay = delay + 's';

        frag.appendChild(el);
        bgWords.push({ el: el, leftPct: left, topPct: top, offsetX: 0, offsetY: 0 });
      }
    }

    container.appendChild(frag);
    requestAnimationFrame(repelLoop);
  }

  function updatePointer(x, y) {
    pointer.x = x;
    pointer.y = y;
  }

  window.addEventListener('pointermove', function (e) {
    updatePointer(e.clientX, e.clientY);
  });

  window.addEventListener('pointerleave', function () {
    pointer.x = -9999;
    pointer.y = -9999;
  });

  window.addEventListener(
    'touchmove',
    function (e) {
      if (e.touches && e.touches.length) {
        updatePointer(e.touches[0].clientX, e.touches[0].clientY);
      }
    },
    { passive: true }
  );

  window.addEventListener(
    'touchstart',
    function (e) {
      if (e.touches && e.touches.length) {
        updatePointer(e.touches[0].clientX, e.touches[0].clientY);
      }
    },
    { passive: true }
  );

  window.addEventListener('touchend', function () {
    pointer.x = -9999;
    pointer.y = -9999;
  });

  function repelLoop() {
    if (!document.body.classList.contains('twenty-playing')) {
      var vw = window.innerWidth;
      var vh = window.innerHeight;

      for (var i = 0; i < bgWords.length; i++) {
        var w = bgWords[i];
        var baseX = (w.leftPct / 100) * vw;
        var baseY = (w.topPct / 100) * vh;
        var curX = baseX + w.offsetX;
        var curY = baseY + w.offsetY;
        var dx = curX - pointer.x;
        var dy = curY - pointer.y;
        var dist = Math.sqrt(dx * dx + dy * dy);

        var targetX = 0;
        var targetY = 0;
        if (dist < REPEL_RADIUS) {
          var push = (1 - dist / REPEL_RADIUS) * REPEL_STRENGTH;
          var nx = dist === 0 ? Math.random() - 0.5 : dx / dist;
          var ny = dist === 0 ? Math.random() - 0.5 : dy / dist;
          targetX = nx * push;
          targetY = ny * push;
        }

        w.offsetX += (targetX - w.offsetX) * 0.15;
        w.offsetY += (targetY - w.offsetY) * 0.15;
        w.el.style.transform = 'translate(' + w.offsetX.toFixed(1) + 'px,' + w.offsetY.toFixed(1) + 'px)';
      }
    }

    requestAnimationFrame(repelLoop);
  }

  initBgWords();

  var birdImg = new Image();
  birdImg.src = document.getElementById('eye-logo').src;

  var width = 0;
  var height = 0;
  var dpr = Math.max(1, window.devicePixelRatio || 1);

  var bird = { y: 0, vy: 0, rotation: 0 };
  var pipes = [];
  var score = 0;
  var running = false;
  var lastPipeTime = 0;
  var lastFrameTimestamp = 0;
  var rafId = null;

  function resizeCanvas() {
    width = gameScreen.clientWidth || window.innerWidth;
    height = gameScreen.clientHeight || window.innerHeight;
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    canvas.style.width = width + 'px';
    canvas.style.height = height + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  window.addEventListener('resize', resizeCanvas);

  function resetGame() {
    resizeCanvas();
    bird.y = height / 2;
    bird.vy = 0;
    bird.rotation = 0;
    pipes = [];
    score = 0;
    lastPipeTime = 0;
    lastFrameTimestamp = 0;
    updateHud();
  }

  function updateHud() {
    hudEl.textContent = String(score);
    if (score > sessionBest) {
      sessionBest = score;
    }
    sessionBestEl.textContent = 'BEST: ' + sessionBest;
  }

  function flap() {
    if (!running) return;
    bird.vy = FLAP_VELOCITY;
  }

  function spawnPipe() {
    var gap = currentPipeGap();
    var margin = 60;
    var gapCenter = margin + Math.random() * (height - margin * 2 - gap) + gap / 2;
    pipes.push({
      x: width + PIPE_WIDTH,
      gapCenter: gapCenter,
      gap: gap,
      passed: false
    });
  }

  function rectsOverlap(ax, ay, aw, ah, bx, by, bw, bh) {
    return ax < bx + bw && ax + aw > bx && ay < by + bh && ay + ah > by;
  }

  function checkCollision() {
    var birdX = width * BIRD_X_RATIO;
    var half = BIRD_SIZE / 2;

    if (bird.y - half <= 0 || bird.y + half >= height) return true;

    for (var i = 0; i < pipes.length; i++) {
      var p = pipes[i];
      var topHeight = p.gapCenter - p.gap / 2;
      var bottomY = p.gapCenter + p.gap / 2;

      var hitsTop = rectsOverlap(
        birdX - half, bird.y - half, BIRD_SIZE, BIRD_SIZE,
        p.x, 0, PIPE_WIDTH, topHeight
      );
      var hitsBottom = rectsOverlap(
        birdX - half, bird.y - half, BIRD_SIZE, BIRD_SIZE,
        p.x, bottomY, PIPE_WIDTH, height - bottomY
      );

      if (hitsTop || hitsBottom) return true;
    }
    return false;
  }

  function drawPipe(p) {
    var topHeight = p.gapCenter - p.gap / 2;
    var bottomY = p.gapCenter + p.gap / 2;

    ctx.fillStyle = '#000000';
    ctx.fillRect(p.x, 0, PIPE_WIDTH, topHeight);
    ctx.fillRect(p.x, bottomY, PIPE_WIDTH, height - bottomY);

    ctx.strokeStyle = '#ffffff';
    ctx.lineWidth = 2;
    ctx.strokeRect(p.x, 0, PIPE_WIDTH, topHeight);
    ctx.strokeRect(p.x, bottomY, PIPE_WIDTH, height - bottomY);
  }

  function draw() {
    ctx.clearRect(0, 0, width, height);

    for (var i = 0; i < pipes.length; i++) drawPipe(pipes[i]);

    var birdX = width * BIRD_X_RATIO;
    ctx.save();
    ctx.translate(birdX, bird.y);
    ctx.rotate(bird.rotation);
    ctx.drawImage(birdImg, -BIRD_SIZE / 2, -BIRD_SIZE / 2, BIRD_SIZE, BIRD_SIZE);
    ctx.restore();
  }

  function loop(timestamp) {
    if (!running) return;

    if (!lastFrameTimestamp) lastFrameTimestamp = timestamp;
    var dt = (timestamp - lastFrameTimestamp) / (1000 / 60);
    dt = Math.min(Math.max(dt, 0), 3);
    lastFrameTimestamp = timestamp;

    if (!lastPipeTime) lastPipeTime = timestamp;
    if (timestamp - lastPipeTime > PIPE_INTERVAL_MS) {
      spawnPipe();
      lastPipeTime = timestamp;
    }

    bird.vy += GRAVITY * dt;
    bird.y += bird.vy * dt;
    bird.rotation = Math.max(-0.5, Math.min(1.1, bird.vy / 12));

    var birdX = width * BIRD_X_RATIO;
    var speed = currentPipeSpeed() * dt;
    for (var i = pipes.length - 1; i >= 0; i--) {
      pipes[i].x -= speed;

      if (!pipes[i].passed && pipes[i].x + PIPE_WIDTH < birdX) {
        pipes[i].passed = true;
        score += 1;
        updateHud();
      }

      if (pipes[i].x + PIPE_WIDTH < 0) pipes.splice(i, 1);
    }

    draw();

    if (checkCollision()) {
      endGame();
      return;
    }

    rafId = requestAnimationFrame(loop);
  }

  function startGame() {
    landingScreen.style.display = 'none';
    gameOverScreen.style.display = 'none';
    gameScreen.style.display = 'flex';
    document.body.classList.add('twenty-playing');

    resetGame();
    running = true;
    rafId = requestAnimationFrame(loop);
  }

  function endGame() {
    running = false;
    document.body.classList.remove('twenty-playing');
    if (rafId) cancelAnimationFrame(rafId);

    var best = parseInt(localStorage.getItem(BEST_KEY) || '0', 10);
    if (score > best) {
      best = score;
      localStorage.setItem(BEST_KEY, String(best));
    }

    scoreEl.textContent = String(score);
    bestEl.textContent = String(best);

    if (incentiveEl) {
      incentiveEl.style.display = score >= WIN_SCORE ? 'block' : 'none';
    }

    gameScreen.style.display = 'none';
    gameOverScreen.style.display = 'flex';
  }

  playButton.addEventListener('click', startGame);
  restartButton.addEventListener('click', startGame);

  canvas.addEventListener('pointerdown', function (e) {
    e.preventDefault();
    flap();
  });

  window.addEventListener('keydown', function (e) {
    if (e.code === 'Space' && running) {
      e.preventDefault();
      flap();
    }
  });

  var best = parseInt(localStorage.getItem(BEST_KEY) || '0', 10);
  if (bestEl) bestEl.textContent = String(best);
})();
